const priceFilter = (
  value?: number | null,
  options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: 'USD'
  },
): string | undefined => {
  if (value === null || value === undefined) { return undefined };

  return new Intl.NumberFormat('en-US', options).format(value);
};

export { priceFilter };
export default priceFilter;
